import styled from "styled-components";

/**
 * Wrapper do cabeçalho
 * Configura layout flexível para exibição do título e botões.
 */
export const HeaderWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(6)}
    ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.black};
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

/**
 * Botão de navegação
 * Configura botões para alternar entre os meses com estados de hover e active.
 */
export const NavigationButton = styled.button`
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  transition: all 0.3s ease-in-out;
  background: none;
  cursor: pointer;
  border: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGray};
  }

  &:active {
    transform: scale(0.95);
  }
`;

/**
 * Título do cabeçalho
 * Estiliza o mês e o ano com separação visual.
 */
export const Title = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  gap: ${({ theme }) => theme.spacing(1)};
  grid-template-columns: 1.2fr 0.8fr;
  text-transform: capitalize;
  display: grid;

  & > span:nth-child(2) {
    padding-left: ${({ theme }) => theme.spacing(1)};
    position: relative;

    &:before {
      content: "";
      position: absolute;
      left: -1px;
      top: 2px;
      width: ${({ theme }) => theme.spacing(0.25)};
      height: 80%;
      background-color: ${({ theme }) => theme.colors.black};
    }
  }
`;
